import { render, staticRenderFns } from "./list.vue?vue&type=template&id=c93bc702&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=c93bc702&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93bc702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93bc702')) {
      api.createRecord('c93bc702', component.options)
    } else {
      api.reload('c93bc702', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=c93bc702&scoped=true", function () {
      api.rerender('c93bc702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/openReturn/list.vue"
export default component.exports